// extracted by mini-css-extract-plugin
module.exports = {"highlighted":"HighlightedText_highlighted__3e7Q5"};